'use strict';

angular.module('teams').factory('XtmIntegration', ['$resource',
	function($resource) {
		return $resource('v1/xtm', {
			mobileAppId: '@mobileAppId'
		}, {
			createAccessToken: {
				method: 'POST',
				url : 'v1/xtm/:mobileAppId/createAccessToken',
				isArray: false,
				cache : false
			},
			deleteXtmCustomer: {
				method: 'DELETE',
				url : 'v1/xtm/:mobileAppId',
				isArray: false,
				cache : false
			}
		});
	}
]);
